var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export default function number(x) {
    return x === null ? NaN : +x;
}
export function numbers(values, valueof) {
    var _i, values_1, value, index, _a, values_2, value;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(valueof === undefined)) return [3 /*break*/, 5];
                _i = 0, values_1 = values;
                _b.label = 1;
            case 1:
                if (!(_i < values_1.length)) return [3 /*break*/, 4];
                value = values_1[_i];
                if (!(value != null && (value = +value) >= value)) return [3 /*break*/, 3];
                return [4 /*yield*/, value];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 9];
            case 5:
                index = -1;
                _a = 0, values_2 = values;
                _b.label = 6;
            case 6:
                if (!(_a < values_2.length)) return [3 /*break*/, 9];
                value = values_2[_a];
                if (!((value = valueof(value, ++index, values)) != null && (value = +value) >= value)) return [3 /*break*/, 8];
                return [4 /*yield*/, value];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8:
                _a++;
                return [3 /*break*/, 6];
            case 9: return [2 /*return*/];
        }
    });
}
